// extracted by mini-css-extract-plugin
export default {"shell":"styles_shell__lr6ot","shellScrollable":"styles_shellScrollable__6bJ+1","contentOverflowVisible":"styles_contentOverflowVisible__Ws+xT"};